import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { darcula } from 'react-syntax-highlighter/dist/esm/styles/prism';

export interface CodeViewerOptions {
  language: string,
  children: any
}

export const CodeViewer = ({ language, children }: CodeViewerOptions) => {
  return (
    <SyntaxHighlighter 
      language={ language } 
      style={ darcula }
      showLineNumbers={ true }
    >
      { children }
    </SyntaxHighlighter>
  );
};